import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';

const ManagerLanding: FunctionComponent = () => {
  return (
    <>
      <Typography sx={{ fontSize: '1.2rem', mt: 2 }}>Manager Landing</Typography>
    </>
  );
};

export default ManagerLanding;
